// API base — default por hostname. localhost vai pro backend local;
// qualquer outro host (cloudflare pages, dominio custom) vai pro
// backend hospedado em GCP Compute Engine via api.trucotorneios.com.
// Migrado de Cloud Run em 2026-05-26 pra cortar custo de WS persistente.
export const DEFAULT_API_BASE = (() => {
  const isLocal =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1');
  return isLocal
    ? 'http://localhost:8080'
    : 'https://api.trucotorneios.com';
})();

// localStorage keys — prefixados com `truco.` pra nao colidir com outros apps
// servidos no mesmo dominio.
export const STORAGE_KEYS = {
  apiBase: 'truco.apiBase',
  token: 'truco.token',
  userId: 'truco.userId',
  userName: 'truco.userName',
  avatar: 'truco.avatar',
  haptics: 'truco.haptics',
} as const;
